'use client';

import {styled} from "@mui/system";
import CustomTitleContainer from "@/src/mui-custom/title/custom-title-container";

const ArchiveTitleContainer = styled(CustomTitleContainer)(({theme}) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

export default ArchiveTitleContainer;
